export default {
    url: '',
    template: '<manage-permissions-sites-list/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/sites/list/index.js